import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router';
import { url } from '../api';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';

const NextItems = () => {
  const query = useQuery({
    queryKey: ['workItems'],
    queryFn: () =>
      axios
        .get(url('/next-item'), {
          withCredentials: true,
        })
        .then((res) => res.data),
  });
  if (query.isError) {
    return <div>Error</div>;
  }

  if (query.isLoading || query.data === undefined) {
    return <LoadingSpinner />;
  }

  if (query.data.length === 0) {
    return <div>No Items</div>;
  }
  const params = new URLSearchParams(query.data.map((item: any) => ['itemId', item.id]));
  const workUrl = `/items?${params}`;
  return <Navigate to={workUrl} />;
};

export default NextItems;
